/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {ReviewStatus, ReviewerStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ReviewSummaryProps as ReviewSummaryContentProps} from 'nav/sidepanel/HomeSidepanel';
import {getDefaultSearchSearchParams} from 'nav/sidepanel/listing/SearchSearchParams';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import ReviewConstants, {IN_PROGRESS_FILTER, SENT_FOR_REVIEW} from 'notebook/reviews/ReviewConstants';
import {getStore} from 'redux-stores/Store';
import {FilterKey, keyToEmptyFilter} from 'search/SearchConstants';
import * as SearchUtil from 'search/SearchUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import isModelTypeEnabledForListing from 'util/isModelTypeEnabledForListing';

import * as SidepanelActions from '../sidepanel/SidepanelActions';

interface ReviewSummaryItemProps {
  count: number;
  icon: BenchlingIconName;
  iconClassName?: string;
  onClick: (...args: Array<any>) => any;
  text: string;
  reviewStatus: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ReviewSummaryItem = ({
  icon,
  iconClassName,
  count,
  text,
  reviewStatus,
  onClick,
}: ReviewSummaryItemProps) => (
  <div className="homeSidepanel-today-item-with-icon" onClick={onClick}>
    <BenchlingIcon className={`homeSidepanel-today-review-icon ${iconClassName}`} icon={icon} />
    <span
      className="whiteLink"
      {...getTestProps({
        component: 'ReviewSummaryItem',
        element: 'root',
        key: reviewStatus,
      })}
    >
      {`${count} ${text}`}
    </span>
  </div>
);

interface ReviewSummaryProps {
  reviewableType: string;
  reviewSummary: ReviewSummaryContentProps;
}

class ReviewSummary extends React.Component<ReviewSummaryProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _setReviewFilter = (reviewStatusFilter: any, roleFilter: any, reviewerStatusFilter: any = null) => {
    const modelTypes =
      this.props.reviewableType === 'entry'
        ? [ModelTypeConstants.ENTRY, ModelTypeConstants.STAGE_ENTRY]
        : [ModelTypeConstants.WORKSHEET];
    getStore().dispatch(
      SidepanelReduxActions.openListing(
        NavConstants.Section.SEARCH,
        SearchUtil.mergeFiltersToSearchParams(getDefaultSearchSearchParams(), [
          {
            ...keyToEmptyFilter(FilterKey.TYPES),
            value: modelTypes.filter((type) => isModelTypeEnabledForListing(type)),
          },
          {
            ...keyToEmptyFilter(FilterKey.REVIEW),
            value: {
              review_status: reviewStatusFilter,
              reviewerStatus: reviewerStatusFilter,
              role: roleFilter,
            },
          },
        ])
      )
    );
    SidepanelActions.expand();
  };

  _handleFilterNeedsRevisionEntries = (): void => {
    this._setReviewFilter(ReviewConstants.REJECTED, ReviewConstants.ROLE_FILTERS.AUTHOR_OR_AUDITOR);
  };

  _handleFilterReadyForReviewEntries = (): void => {
    this._setReviewFilter(
      ReviewConstants.NEEDS_REVIEW,
      ReviewConstants.ROLE_FILTERS.AUDITOR,
      ReviewerStatus.PENDING
    );
  };

  _handleFilterSentForReviewEntries = (): void => {
    this._setReviewFilter(ReviewConstants.NEEDS_REVIEW, ReviewConstants.ROLE_FILTERS.AUTHOR);
  };

  _handleFilterAcceptedEntries = (): void => {
    this._setReviewFilter(ReviewConstants.ACCEPTED, ReviewConstants.ROLE_FILTERS.AUTHOR_OR_AUDITOR);
  };

  _handleFilterInProgressEntries = (): void => {
    this._setReviewFilter(ReviewConstants.IN_PROGRESS_FILTER, ReviewConstants.ROLE_FILTERS.AUTHOR_OR_AUDITOR);
  };

  render(): JSX.Element {
    const revisionCount = this.props.reviewSummary.rejected;
    const readyForReviewCount = this.props.reviewSummary.needsReview;
    const sentForReviewCount = this.props.reviewSummary.sentForReview;
    const acceptedCount = this.props.reviewSummary.accepted;
    const inProgressCount = this.props.reviewSummary.inProgress + this.props.reviewSummary.retracted;
    return (
      <div className="homeSidepanel-today-review">
        <div className="u-flex-display u-small-spacing-bottom">
          <ReviewSummaryItem
            count={inProgressCount}
            icon={IN_PROGRESS_FILTER}
            iconClassName="homeSidepanel-today-review-icon--inProgress"
            onClick={this._handleFilterInProgressEntries}
            text="in progress"
            reviewStatus={ReviewConstants.IN_PROGRESS_FILTER}
          />
          <ReviewSummaryItem
            count={revisionCount}
            icon={ReviewStatus.REJECTED}
            iconClassName="homeSidepanel-today-review-icon--rejected"
            onClick={this._handleFilterNeedsRevisionEntries}
            text={revisionCount === 1 ? 'needs revision' : 'need revision'}
            reviewStatus={ReviewConstants.REJECTED}
          />
        </div>
        <div className="u-flex-display u-small-spacing-bottom">
          <ReviewSummaryItem
            count={readyForReviewCount}
            icon={ReviewStatus.NEEDS_REVIEW}
            iconClassName="homeSidepanel-today-review-icon--review"
            onClick={this._handleFilterReadyForReviewEntries}
            text="ready for review"
            reviewStatus={ReviewConstants.NEEDS_REVIEW}
          />
          <ReviewSummaryItem
            count={sentForReviewCount}
            icon={SENT_FOR_REVIEW}
            onClick={this._handleFilterSentForReviewEntries}
            text="sent for review"
            reviewStatus={ReviewConstants.SENT_FOR_REVIEW}
          />
        </div>
        <div className="u-flex-display">
          <ReviewSummaryItem
            count={acceptedCount}
            icon={ReviewStatus.ACCEPTED}
            iconClassName="homeSidepanel-today-review-icon--accepted"
            onClick={this._handleFilterAcceptedEntries}
            text={BenchlingConfig.ENABLE_ENTRY_REVIEW_PROCESSES ? 'completed' : 'accepted'}
            reviewStatus={ReviewConstants.ACCEPTED}
          />
        </div>
      </div>
    );
  }
}

export default ReviewSummary;
